import { store } from "@/shared-store";
import { Store } from "vuex";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { EcommerceUrlReturnCodes } from "@/apps/merchant3/types/EcommerceUrlReturnCodes";
import { isEcommerceFlow } from "@/apps/merchant3/helpers/checkoutFlows";
import cancelCartState from "@/apps/merchant3/hooks/cancelCartState";
import router from "@/router";
import { RouteName } from "@/apps/merchant3/router/RouteName";
import { getCountryCode } from "@/apps/merchant3/helpers/flowType";
import { SessionStorageEnum } from "@/apps/merchant3/enums/sessionStorageEnum";
import { utils } from "@/apps/merchant3/shared/utils";

export const getRedirectToAdminPageUrl = (
  code: string,
  defaultCartTag?: string
): string => {
  const vuexStore = store as unknown as Store<IVuexState>;
  const redirectUrl = sessionStorage.getItem(SessionStorageEnum.RedirectUrl);
  const cartTag = vuexStore.state.carts.cartTag || defaultCartTag;
  if (!redirectUrl || !cartTag) {
    return "";
  }

  return getForwardToUrl(redirectUrl, code, cartTag);
};

const getForwardToUrl = (
  redirectUrl: string,
  code: string,
  cartTag: string
) => {
  const url = new URL(redirectUrl);
  url.searchParams.append("code", code);
  url.searchParams.append("cartTag", cartTag);
  return url.toString();
};

export const clearStoreAndNavigateHome = async (
  ecommerceReturnCode = EcommerceUrlReturnCodes.CANCELED
): Promise<void> => {
  const vuexStore = store as unknown as Store<IVuexState>;
  let redirectUrl: string | null = null;
  const step = vuexStore.state?.carts?.step;

  // Check if we are in an ecommerce flow before cleaning the stores
  // Use sessionStorage as a fallback indicator in case Vuex state was lost
  // (e.g., when returning from external payment provider like OpenPay)
  const sessionRedirectUrl = sessionStorage.getItem(
    SessionStorageEnum.RedirectUrl
  );
  const sessionCartTag = sessionStorage.getItem(SessionStorageEnum.CartTag);
  if (isEcommerceFlow.value || sessionRedirectUrl) {
    // Pass sessionCartTag as fallback in case Vuex state is empty
    redirectUrl = getRedirectToAdminPageUrl(
      ecommerceReturnCode,
      sessionCartTag || undefined
    );
  }

  await cancelCartState();
  doRedirection(step, redirectUrl);
};

export const doRedirection = (
  step?: string | null,
  redirectUrl?: string | null
): void => {
  // Navigation should happen after clearing the store.
  setTimeout(() => {
    if (redirectUrl) {
      sessionStorage.clear();
      // If we reach this function from Ecommerce, it means the sale has been finished from our side
      sessionStorage.setItem(
        SessionStorageEnum.EcommerceSaleFinished,
        JSON.stringify(true)
      );
      window.location.href = redirectUrl;
    } else {
      step = step ? utils.toSnakeCase(step) : "";
      router.replace({
        name: RouteName.M3Welcome,
        params: { countryCode: getCountryCode() },
        query: { hasSurvey: "true", step },
      });
    }
  }, 1);
};
